module.exports = __webpack_public_path__ + "img/scene-1.2ea5c336.png";